/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserPreferencesV3 } from '../../models/user-preferences-v-3';

export interface GetUserPreferencesV3$Params {
}

export function getUserPreferencesV3(http: HttpClient, rootUrl: string, params?: GetUserPreferencesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPreferencesV3>> {
  const rb = new RequestBuilder(rootUrl, getUserPreferencesV3.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserPreferencesV3>;
    })
  );
}

getUserPreferencesV3.PATH = '/users/preferences';
